export default "__VITE_ASSET__ea615eee__"